<div class="password-dialog">
  <div class="content">
    <h2 class="title">Change Password</h2>
    <p class="subtitle">Please enter your new password</p>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmitNewPassword()">
      <div class="input-group">
        <label for="new-password" class="input-label"
          >New Password <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <input
            [type]="inputType.newPassword"
            name="newPassword"
            id="new-password"
            placeholder="Input your new password"
            autocomplete="off"
            formControlName="newPassword"
            class="password-input"
          />
          <i
            [class]="inputType.newPassword === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"
            class="input-icon"
            (click)="toggleInputType('newPassword')"
          ></i>
        </div>
        <div
          class="password-requirements"
          *ngIf="
            passwordForm.get('newPassword')?.touched &&
            !passwordForm.get('newPassword')?.hasError('invalidPassword')
          "
        >
          Password must be at least 8 characters, contain at least 1 uppercase letter, 1 symbol, and
          1 number
        </div>
        <div class="field-error-messages">
          <div
            *ngIf="
              passwordForm.get('newPassword')?.hasError('invalidPassword') &&
              passwordForm.get('newPassword')?.touched &&
              !passwordForm.get('newPassword')?.hasError('required') &&
              !(
                passwordForm.get('newPassword')?.value ===
                passwordForm.get('reEnterPassword')?.value
              )
            "
            class="error-message"
          >
            <i class="pi pi-exclamation-triangle"></i> Password must have at least 8 characters,
            including uppercase, lowercase, number, and symbol.
          </div>
        </div>
      </div>

      <div class="input-group">
        <label for="re-enter-password" class="input-label"
          >Confirm New Password <span class="required">*</span></label
        >
        <div class="input-wrapper">
          <input
            [type]="inputType.reEnterPassword"
            name="reEnterPassword"
            id="re-enter-password"
            placeholder="Confirm your new password"
            autocomplete="off"
            formControlName="reEnterPassword"
            class="password-input"
          />
          <i
            [class]="inputType.reEnterPassword === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"
            class="input-icon"
            (click)="toggleInputType('reEnterPassword')"
          ></i>
        </div>
        <div
          class="password-requirements"
          *ngIf="
            passwordForm.get('reEnterPassword')?.touched &&
            !passwordForm.get('reEnterPassword')?.hasError('required') &&
            !passwordForm.get('reEnterPassword')?.hasError('invalidPassword') &&
            passwordForm.get('newPassword')?.value === passwordForm.get('reEnterPassword')?.value
          "
        >
          Password must be at least 8 characters, contain at least 1 uppercase letter, 1 symbol, and
          1 number
        </div>
        <div class="field-error-messages">
          <!-- <div
            *ngIf="
              passwordForm.get('reEnterPassword')?.hasError('invalidPassword') &&
              passwordForm.get('reEnterPassword')?.touched &&
              !passwordForm.get('reEnterPassword')?.hasError('required')
            "
            class="error-message"
          >
            <i class="pi pi-exclamation-triangle"></i> Password must have at least 8
            characters, including uppercase, lowercase, number, and symbol.
          </div> -->
          <div
            *ngIf="
              passwordForm.get('newPassword')?.value &&
              passwordForm.get('reEnterPassword')?.value &&
              passwordForm.get('newPassword')?.value !==
                passwordForm.get('reEnterPassword')?.value &&
              passwordForm.get('reEnterPassword')?.touched
            "
            class="error-message"
          >
            <i class="pi pi-exclamation-triangle"></i> Your confirmation password doesn't match the
            new password
          </div>
        </div>
      </div>
      <!-- 
      <div class="error-messages" *ngIf="error() !== ''">
        <div class="error-message">
          <i class="pi pi-exclamation-triangle"></i> {{ error() }}
        </div>
      </div> -->

      <div class="button-group">
        <lib-button type="Secondary" label="Cancel" (click)="onCancel()"></lib-button>
        <lib-button
          label="Next"
          [disabled]="
            passwordForm.invalid ||
            !passwordForm.get('newPassword')?.value ||
            passwordForm.get('reEnterPassword')?.value !== passwordForm.get('newPassword')?.value
          "
          type="Primary"
        >
        </lib-button>
      </div>
    </form>
  </div>
</div>
